import React from "react";
import { connect } from "react-redux";
import { config } from "config";
import { STATIC_URLS } from "consts";

const originalFileRestorePopup = props => {
  return (
    <div class="res_original_location">
      <p>
        Restoring data to original location lets you restore files to the same
        location on your computer, from where they were backed up to your IDrive
        Mirror account.
      </p>
      <strong>
        Read carefully before you choose to restore files to their original
        location:
      </strong>
      <ul>
        <li>
          ➤ For restoring files to the original location on your computer, the
          files/folders structure should be the same as it appears in your cloud
          backup.
        </li>
        <li>
          ➤ Restoring files to their original location on the computer will
          overwrite the existing files with their corresponding latest file
          version, available in your cloud backup.
        </li>
        <li>
          ➤ During restore, if IDrive Mirror cannot overwrite a file due to
          limited access rights or other issues, it will skip restoring the
          file. To restore the file to a different location, select a specific
          destination on your computer instead of the original backup location.
        </li>
        <li>
          ➤ Operating System and application-related folders like 'Windows',
          'Program Files', etc., are not considered for 'Restore to Original
          Location' to ensure smooth functioning of your computer.
        </li>
        <li>
          ➤ Refer to the{" "}
          <a
            href={
              STATIC_URLS.origLocRestore[
                props?.origin === "idrive" ? "idrive" : config.APP_INSTANCE
              ]
            }
            target="_blank"
          >
            FAQ
          </a>{" "}
          regarding the list of files omitted for restore to original location.
        </li>
      </ul>
    </div>
  );
};

function mapStateToProps(state) {
  return {
    origin: state.account.origin
  };
}

export default connect(mapStateToProps)(originalFileRestorePopup);
